export const APP_STATE = {
    Initialized: 'APP/Initialized',
    Initializing: 'APP/Initializing',
    Error: 'APP/Error',
    UpdateField: 'APP/UPDATE_FIELD'    
};